module.exports = __webpack_public_path__ + "static/img/brand_6.b55cb31.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/homepage/brand_6.jpg
// module id = mq+e
// module chunks = 1